import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Cadastro from "../pages/cadastro/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/cadastro/:slug",
    element: <Cadastro />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
